import React, { useState, useEffect } from 'react';
import { getSettings } from '../../util/getSettings';
import { filterDefaults } from '../../util/filters';
import Slider from '../shared/slider';

const PriceRange = ({ minPrice, maxPrice, onChange }) => {
  const [selectedMinPrice, setSelectedMinPrice] = useState(null);
  const [selectedMaxPrice, setSelectedMaxPrice] = useState(null);
  const labels = getSettings(['century', 'labels'], true);

  useEffect(() => {
    setSelectedMinPrice(minPrice);
    setSelectedMaxPrice(maxPrice);
  }, [minPrice, maxPrice]);

  const onSliderChange = (sliderValues) => {
    const _minPrice = sliderValues.selectedMin;
    const _maxPrice = sliderValues.selectedMax;
    setSelectedMinPrice(_minPrice);
    setSelectedMaxPrice(_maxPrice);
    onChange(_minPrice, _maxPrice);
  };

  return (
    <Slider
      title={labels.priceRangeLabel}
      minValue={filterDefaults.minPrice}
      maxValue={filterDefaults.maxPrice}
      selectedMinValue={selectedMinPrice}
      selectedMaxValue={selectedMaxPrice}
      minInputLabel={labels.minPriceLabel}
      maxInputLabel={labels.maxPriceLabel}
      onSliderChange={onSliderChange}
      step={5000}
      currency
      maxPricePlus
    />
  );
};

export default PriceRange;
